import { Logo, Container, A } from '#app/ui/components'
import { appName } from '#app/utils/constants.js'

export const Footer = () => {
	const navigation = {
		legal: [
			{ name: `Legal Notice`, href: `/legal-notice` },
			{ name: `Privacy Policy`, href: `/privacy-policy` },
			{ name: `Purchase Conditions`, href: `/purchase-conditions` },
			{ name: `Registration Conditions`, href: `/registration-conditions` },
		],
		social: [
			{
				name: `Instagram`,
				href: `https://www.instagram.com/welovenight.es?igsh=MWRiYnRka2xxeTU5dQ==`,
				icon: (props: any) => (
					<svg fill="currentColor" viewBox="0 0 24 24" {...props}>
						<path
							fillRule="evenodd"
							d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
							clipRule="evenodd"
						/>
					</svg>
				),
			},
		],
	}
	return (
		<div className="bg-[#F5CDFF] pt-20 text-brand-deep-black">
			<Container>
				<footer className="pb-5">
					<h2 id="footer-heading" className="sr-only">
						Footer
					</h2>
					<div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between">
						<div className="space-y-8">
							<Logo variant="dark" />
							<div className="flex space-x-6">
								{navigation.social.map((item) => (
									<a
										key={item.name}
										href={item.href}
										target="_blank"
										className="text-muted-500 hover:text-muted-600"
									>
										<span className="sr-only">{item.name}</span>
										<item.icon aria-hidden="true" className="h-6 w-6" />
									</a>
								))}
							</div>
						</div>
						<div>
							<h3 className="font-bold leading-6">Legal</h3>
							<ul role="list" className="mt-6 space-y-4">
								{navigation.legal.map((item) => (
									<li key={item.name}>
										<A href={item.href} className="text-sm leading-6">
											{item.name}
										</A>
									</li>
								))}
							</ul>
						</div>
					</div>
					<div className="border-brand-muted-amethyst mt-16 border-t pt-8 sm:mt-20 lg:mt-24">
						<p className="text-xs leading-5 text-muted-600">
							&copy; {new Date().getFullYear()} {appName}, Inc. All rights
							reserved.
						</p>
					</div>
				</footer>
			</Container>
		</div>
	)
}
